import BaseDialog from "./BaseDialog";
import { useEffect } from "react";

interface IDeleteModal {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => any;
  cancelLabel?: string;
  confirmLabel?: string;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  isLoading?: boolean;
}

export function DeleteModal({
  isOpen,
  onClose,
  onDelete,
  cancelLabel = "Cancel",
  confirmLabel = "Delete",
  title,
  description,
  isLoading,
}: IDeleteModal) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!isOpen) return;

      if (event.key === "Enter" && !isLoading) {
        onDelete();
      } else if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onDelete, onClose, isLoading]);

  return (
    <BaseDialog
      title={title || "Are you sure you want to delete?"}
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      size="md"
      compact
      footerActions={[
        {
          label: cancelLabel,
          props: {
            variant: "ghost",
            onClick: onClose,
          },
        },
        {
          label: confirmLabel,
          props: {
            variant: "destructive",
            onClick: onDelete,
            loading: isLoading,
          },
        },
      ]}
    >
      <p className="text-sm text-muted-foreground">
        {description || "You won't be able to revert this action."}
      </p>
    </BaseDialog>
  );
}
